import { TextLink } from '@airwallex/typography';
import styled from '@emotion/styled';
import { CSSProperties } from 'react';

export const LineItemsShowMoreButton = styled(TextLink)`
  display: inline-block;
  &:hover {
    text-decoration: none;
  }
`;

export const LineItemsWrapper = styled.div<{ showMoreButtonShown: boolean; isMobile: boolean }>`
  ${({ showMoreButtonShown }) => lineItemsTableSharedCss(showMoreButtonShown)}
  ${({ isMobile }) =>
    isMobile
      ? `

    & td:first-of-type dl dt > div > div {
      justify-content: flex-start;
    }
  `
      : ''}
`;

export function lineItemsTableSharedCss(showMoreButtonShown: boolean): string {
  return `
  & table span, & table p {
    font-size: 12px;
  }
  & table tbody span, & table tbody p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  /* FEC wraps cell content in span; discount label must wrap instead of single-line ellipsis */
  & td:has([data-row-type='discount']) span,
  & td:has([data-row-type='discount']) p {
    overflow: visible;
    text-overflow: unset;
    max-width: none;
  }
  ${
    showMoreButtonShown
      ? `
    & tbody > tr:nth-last-child(2) > td {
      border-bottom: none !important;
    }
    & tbody > tr:last-child > td {
      height: 56px;
      padding-block: 0;
    }
    & tbody > tr:last-child > td > span {
      min-height: unset;
    }
  `
      : ''
  }
  & td:has([data-row-type='discount']) > div {
    display: none;
  }
  & tfoot {
    display: none;
  }
`;
}

export const ellipsisStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  whiteSpace: 'nowrap',
  width: '100%',
} as CSSProperties;
